import React, { Children, PropsWithChildren } from 'react';
import { Nav } from 'react-bootstrap';
import { Link, useLocation } from 'react-router-dom';
import SubtitleRegular from 'components/Typography/SubtitleRegular';
import DiscreteTab from './Tab';
import './index.scss';

export default function DiscreteTabs({
  children,
  type = 'underline',
  activeKey,
}: PropsWithChildren<{
  activeKey: string;
  type: 'underline' | 'round';
}>) {
  const location = useLocation();
  const tabs = Children.toArray(children) as React.ReactElement<any>[];

  return (
    <Nav
      activeKey={activeKey}
      className={`${type}-discrete-tabs`}
    >
      {tabs.map((tab) => (
        <Link
          key={tab.props.path}
          to={tab.props.path}
          className={`discrete-nav-link ${location.pathname === tab.props.path ? 'active' : ''}`}
        >
          <SubtitleRegular>{tab.props.title}</SubtitleRegular>
        </Link>
      ))}
    </Nav>
  );
}

DiscreteTabs.Tab = DiscreteTab;
